import React, { Component } from "react"

import logo from "../img/0060/logo/logo.png"
import PageMenu from "./PageMenu"

import {
  CompanyLogo,
  CompanyName,
  HeaderFixed,
  HeaderHidden,
  HomeLink
} from "../styled-components"

class PageHeader extends Component {
  render() {
    return (
      <div>
        <HeaderFixed>
          <HomeLink to="/">
            <CompanyLogo src={logo} alt={logo} />
            <CompanyName>STEPHAN ANDERS FOTOGRAFIE</CompanyName>
          </HomeLink>
          <PageMenu />
        </HeaderFixed>
        <HeaderHidden>
          <HomeLink to="/">
            <CompanyLogo src={logo} alt={logo} />
            <CompanyName>STEPHAN ANDERS FOTOGRAFIE</CompanyName>
          </HomeLink>
          <PageMenu />
        </HeaderHidden>
      </div>
    )
  }
}

export default PageHeader



// WEBPACK FOOTER //
// ./src/partials/PageHeader.js